import NYLogo from '~/public/static/images/svg/divorce-ny-logo.svg'
import WinItLogo from '~/public/static/images/svg/logo-shadow.svg'

export const SEARCH_OPTIONS_STATES_LOGOS = {
  NY: { logoUrl: NYLogo, width: 225, height: 45 },
  DEFAULT: { logoUrl: WinItLogo, width: 130, height: 35 },
}
